import { render, staticRenderFns } from "./OrderItemLocationListing.vue?vue&type=template&id=64318e6c&scoped=true"
import script from "./OrderItemLocationListing.vue?vue&type=script&lang=js"
export * from "./OrderItemLocationListing.vue?vue&type=script&lang=js"
import style0 from "./OrderItemLocationListing.vue?vue&type=style&index=0&id=64318e6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64318e6c",
  null
  
)

export default component.exports